module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};



//////////////////
// WEBPACK FOOTER
// /opt/jenkins_home/workspace/marketing-campaigns_deploy_trigger_imp/3203/lib/node_modules/@core/macys-cli/node_modules/core-js/modules/_perform.js
// module id = 118
// module chunks = 0